// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__kWC6o","icon":"SortAdornment_icon__3kOtg","up":"SortAdornment_up__2yQn9","down":"SortAdornment_down__19wZ5","active":"SortAdornment_active__xMkO-"};